module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc12-2a989805681b00197ad696c7caba5b28.jpg";